<template>
  <el-drawer
    class="sideDrawer"
    destroy-on-close
    :size="drawerSize"
    title="提醒规则"
    :visible.sync="show"
    :before-close="handleClose"
    :wrapperClosable="false"
    :append-to-body="true"
  >
    <i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
    <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
    <div class="form-content" style="padding: 20px">
      <el-form ref="form" :model="form" label-width="160px" :rules="rules">
        <el-row>
          <el-col :span="12">
            <el-form-item label="风险维度" prop="dimension_key">
              <el-select v-model="form.dimension_key" placeholder="请选择" @change="dimensionChange" filterable :disabled="tenantId != '-1'">
                <el-option v-for="item in dimensionOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="风险模版" prop="bo_def_key">
              <el-select v-model="form.bo_def_key" placeholder="选择维度后选择" @change="boDefChange" filterable :disabled="tenantId != '-1'">
                <el-option v-for="item in bodefOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" v-if="tabsVal == 1">
            <el-form-item label="风险指标" prop="target_key">
              <el-select v-model="form.target_key" placeholder="选择模板后选择" @change="targetChange" filterable :disabled="tenantId != '-1'">
                <el-option v-for="item in targetNameOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="指标定义" prop="target_def">
              <el-input type="textarea" v-model="form.target_def" :disabled="tenantId != '-1'"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" v-if="tabsVal == 1">
            <el-form-item label="条件运算符" prop="condition_operator">
              <el-select v-model="form.condition_operator" placeholder="请选择" filterable :disabled="tenantId != '-1'">
                <el-option v-for="item in conditionOperatorOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="tabsVal == 1">
            <el-form-item label="条件控制值" prop="condition_ctrl_value">
              <el-input v-model="form.condition_ctrl_value" :disabled="isCanEdit(form.target_key)"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" v-if="tabsVal == 2">
            <el-form-item label="风险等级" prop="risk_level">
              <el-select v-model="form.risk_level" placeholder="请选择" filterable :disabled="tenantId != '-1'">
                <el-option v-for="item in riskLevelOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="tabsVal == 1">
            <el-form-item label="风险等级" prop="risk_level">
              <el-select v-model="form.risk_level" placeholder="请选择" filterable :disabled="tenantId != '-1'">
                <el-option label="一般提醒" value="ybtx"></el-option>
                <el-option label="黄色风险" value="yjtx"></el-option>
                <el-option label="红色风险" value="fxtx"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="tabsVal == 1">
            <el-form-item label="提醒时间" prop="remind_time">
              <el-button type="text" @click="showNoticeTime">设置提醒时间</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="提醒文字模板" prop="word_template">
              <el-select v-model="form.word_template" placeholder="请选择" filterable>
                <el-option v-for="item in wordTemplateOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="state">
              <el-switch v-model="form.state" active-color="#13ce66" inactive-color="#ff4949" active-value="1" inactive-value="0"> </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.word_template == '1'">
          <el-col :span="24">
            <el-form-item label="提醒文字-系统模板" prop="template_key">
              <el-select v-model="form.template_key" placeholder="请选择" :disabled="tenantId != '-1'">
                <el-option v-for="item in remindWordOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="tenantId != '-1' && form.word_template == '2'">
          <el-col :span="20">
            <el-form-item label="提醒文字-自定义" prop="remind_word_diy">
              <el-input v-model="form.remind_word_diy" type="textarea" @blur="blurEvent"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <form-field-selector :boKey="form.bo_def_key" @setField="(params) => setField(params, 'remind_word_diy')"></form-field-selector>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item label="提醒方式" prop="remind_way_list">
              <el-select v-model="form.remind_way_list" multiple @change="remindWayChange" placeholder="请选择">
                <el-option v-for="item in remindWayOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="提醒人" prop="reminder_members">
              <el-input v-model="form.reminder_members" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-link type="primary" :underline="false" style="margin-left: 10px" @click="setPerson">设置提醒人</el-link>
          </el-col>
        </el-row>
        <!-- new-->
        <template v-if="tabsVal == 1">
          <el-row>
            <el-col :span="20">
              <el-form-item label="风险标题" prop="remind_title">
                <el-input v-model="form.remind_title" type="textarea" @blur="blurEvent" :disabled="tenantId != '-1'"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <form-field-selector
                v-if="tenantId === '-1'"
                :boKey="form.bo_def_key"
                @setField="(params) => setField(params, 'remind_title')"
              ></form-field-selector>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="风险描述" prop="risk_describe">
                <el-input v-model="form.risk_describe" type="textarea" @blur="blurEvent" :disabled="tenantId != '-1'"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <form-field-selector
                v-if="tenantId === '-1'"
                :boKey="form.bo_def_key"
                @setField="(params) => setField(params, 'risk_describe')"
              ></form-field-selector>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否显示门户页面" prop="is_portal">
                <el-switch v-model="form.is_portal" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0"> </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item v-if="form.is_portal == 1" label="显示门户页面" prop="portal_type_list">
                <el-select v-model="form.portal_type_list" placeholder="请选择" multiple @change="portalTypeChange">
                  <el-option v-for="item in portalTypeOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="form.is_portal == 1">
            <el-col :span="12">
              <el-form-item label="统计数据" prop="statistics_data">
                <el-select v-model="form.statistics_data" @change="statisticsDataChange" filterable :disabled="tenantId != '-1'">
                  <el-option v-for="item in statisticsDataOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="显示单位" prop="show_unit">
                <el-select v-model="form.show_unit" placeholder="请选择" :disabled="tenantId != '-1'">
                  <el-option
                    v-for="item in form.statistics_data === 'number' ? showUnitOptionsOwn : showUnitOptionsMoney"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item label="统计字段" prop="statistics_field">
                <el-select v-model="form.statistics_field" placeholder="选择模板后选择" filterable :disabled="tenantId != '-1'">
                  <el-option v-for="item in targetNameOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否发起风险任务" prop="F_send_task" v-if="['yjtx', 'fxtx'].includes(form.risk_level)">
                <el-switch v-model="form.F_send_task" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0"> </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="任务整改期限(天)" prop="task_deadline" v-if="['yjtx', 'fxtx'].includes(form.risk_level) && form.F_send_task == 1">
                <el-input type="number" v-model="form.task_deadline"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <!-- new-->
      </el-form>
    </div>
    <div class="demo-drawer__footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSave" v-loading.fullscreen.lock="loading">确 定</el-button>
    </div>
    <notice-person-selector
      ref="noticePersonSelectorRef"
      :show="showPerson"
      :boKey="form.bo_def_key"
      @close="close"
      @onConfirm="onConfirm"
    ></notice-person-selector>
    <notice-time :show="noticeTimeShow" :time="form.remind_time" @closeNoticeTime="closeNoticeTime"></notice-time>
  </el-drawer>
</template>

<script>
import noticePersonSelector from './noticePersonSelector.vue'
import formFieldSelector from './formFieldSelector.vue'
import noticeTime from './noticeTime.vue'
import { mapState } from 'vuex'
import utils from '@/utils.js'
export default {
  components: { noticePersonSelector, formFieldSelector, noticeTime },
  props: {
    tabsVal: {
      type: String,
      default: () => 1
    },
    show: {
      type: Boolean,
      default: () => false
    },
    noticeData: {
      type: Object,
      default: () => {}
    },
    isEdit: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    ...mapState({
      allDataDict: (state) => state.user.allDataDict,
      allEnumerate: (state) => state.user.allEnumerate,
      riskLevelOptions: (state) => {
        let arr = utils.findDictList('fxdj', state.user.allDataDict)
        return arr.map((item) => {
          return {
            value: item.key,
            label: item.name
          }
        })
      },
      portalTypeOptions: (state) => {
        return utils.getAllEnumerateAttr({
          isShowList: true,
          typeKey: 'PortalEnum',
          allData: state.user.allEnumerate
        })
      },
      statisticsDataOptions: (state) => {
        return utils.getAllEnumerateAttr({
          isShowList: true,
          typeKey: 'StatisticDataEnum',
          allData: state.user.allEnumerate
        })
      },
      showUnitOptionsOwn: (state) => {
        return utils.getAllEnumerateAttr({
          isShowList: true,
          typeKey: 'NumberUnitEnum',
          allData: state.user.allEnumerate
        })
      },
      showUnitOptionsMoney: (state) => {
        return utils.getAllEnumerateAttr({
          isShowList: true,
          typeKey: 'AmountUnitEnum',
          allData: state.user.allEnumerate
        })
      }
    })
  },
  watch: {
    noticeData: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          const newObject = {}
          const a = this.form
          const b = newVal
          Object.assign(newObject, a, b)
          this.form = newObject
        }
      }
    },
    'noticeData.dimension_key': {
      deep: true,
      handler(newVal) {
        this.$http.get('${risk}/rule/business_reminder/getModuleByDimensionKey?key=' + newVal).then((res) => {
          if (res.data) {
            res.data.forEach((item) => {
              this.bodefOptions.push({
                value: item.bo_def_key,
                label: item.bo_def
              })
            })
          }
        })
      }
    },
    'noticeData.bo_def_key': {
      deep: true,
      handler(newVal) {
        this.bo_def_key = newVal
        this.$http.get('${risk}/rule/business_reminder/getTargetByModuleKey?key=' + newVal).then((res) => {
          if (res.data) {
            res.data.forEach((item) => {
              this.targetNameOptions.push({
                value: item.target_key,
                label: item.target_name
              })
            })
          }
        })
      }
    }
  },
  data() {
    const checkAlias = (rule, value, callback) => {
      if (this.form.F_send_task == 1 && utils.isEmpty(value)) callback(new Error('任务整改期限(天)必填'))
      else callback()
    }
    const checkPortalTypeList = (rule, value, callback) => {
      if (this.form.is_portal == 1 && utils.isEmpty(value)) callback(new Error('请选择显示门户页面'))
      else callback()
    }
    return {
      tenantId: '-1',
      loading: false,
      showPerson: false,
      noticeTimeShow: false,
      drawerSize: '70%',
      form: {
        word_template: '1',
        statistics_data: '',
        portal_type_list: '',
        show_unit: '',
        statistics_field: '',
        remind_word_diy: '',
        remind_way_list: '',
        bo_def_key: '',
        target_key: '',
        target_def: '',
        condition_operator: '',
        condition_ctrl_value: '',
        risk_level: '',
        remind_title: '',
        is_portal: '',
        risk_describe: '',
        task_deadline: '',
        F_send_task: ''
      },
      dimensionOptions: [],
      bodefOptions: [],
      targetNameOptions: [],
      conditionOperatorOptions: [
        { value: 'GT', label: '大于' },
        { value: 'LT', label: '小于' },
        { value: 'GE', label: '大于等于' },
        { value: 'LE', label: '小于等于' },
        { value: 'EQ', label: '等于' },
        { value: 'NE', label: '不等于' },
        { value: 'LKS', label: '左相似' },
        { value: 'LKE', label: '右相似' },
        { value: 'IN', label: '包含' },
        { value: 'BETWEEN_CONTAIN_BEHIND', label: '介于(含后值)' },
        { value: 'BETWEEN_CONTAIN_FRONT', label: '介于(含前值)' },
        { value: 'BETWEEN', label: '介于(含前后值)' },
        { value: 'BETWEEN_NO_CONTAIN', label: '介于(不含前后值)' }
      ],
      remindWayOptions: [
        { value: 'inner', label: '站内消息' },
        { value: 'dingTalk', label: '钉钉' },
        { value: 'wxEnterprise', label: '微信' }
        // { value: "sms", label: "短信" }
      ],
      wordTemplateOptions: [
        { value: '1', label: '系统模板' },
        { value: '2', label: '自定义模板' }
      ],
      remindWordOptions: [],
      rules: {
        dimension_key: [{ required: true, message: '请选择维度', trigger: 'change' }],
        bo_def_key: [{ required: true, message: '请选择风险模板', trigger: 'change' }],
        target_key: [{ required: true, message: '请选择指标', trigger: 'change' }],
        target_def: [{ required: true, message: '请输入指标定义', trigger: 'blur' }],
        condition_operator: [{ required: true, message: '请选择条件运算符', trigger: 'change' }],
        // condition_ctrl_value: [
        //   { required: true, message: "请输入条件控制值", trigger: "blur" }
        // ],
        risk_level: [{ required: true, message: '请选择风险等级', trigger: 'change' }],
        remind_time: [{ required: true, message: '请选择模提醒时间', trigger: 'change' }],
        word_template: [{ required: true, message: '请选择提醒文字模板', trigger: 'change' }],
        remind_way_list: [{ required: true, message: '请选择提醒方式', trigger: 'change' }],
        reminder_members: [{ required: true, message: '请选择提醒人', trigger: 'change' }],
        template_key: [{ required: true, message: '请选择系统提醒模板', trigger: 'change' }],
        remind_word_diy: [{ required: true, message: '请输入自定义提醒模板', trigger: 'blur' }],
        task_deadline: [{ validator: checkAlias, trigger: 'blur' }],
        portal_type_list: [{ validator: checkPortalTypeList, trigger: 'blur' }]
      },
      blurIndex: null
      // 显示门户页面
      // portalTypeOptions: [],
      // 显示单位
      // showUnitOptionsOwn: [],
      // showUnitOptionsMoney: [],
      // 显示统计数据
      // statisticsDataOptions: []
    }
  },
  mounted() {
    if (sessionStorage.currentTenantId) {
      this.tenantId = sessionStorage.currentTenantId
    }
    this.remindWordOptions = []
    this.$nextTick(() => {
      // let arr = utils.findDictList("fxdj", this.allDataDict);
      // arr.forEach(item => {
      //   this.riskLevelOptions.push({
      //     value: item.key,
      //     label: item.name
      //   });
      // });
      // this.portalTypeOptions = utils.getAllEnumerateAttr({
      //   isShowList: true,
      //   typeKey: "PortalEnum",
      //   allData: this.allEnumerate
      // });
      // this.statisticsDataOptions = utils.getAllEnumerateAttr({
      //   isShowList: true,
      //   typeKey: "StatisticDataEnum",
      //   allData: this.allEnumerate
      // });
      // this.showUnitOptionsOwn = utils.getAllEnumerateAttr({
      //   isShowList: true,
      //   typeKey: "NumberUnitEnum",
      //   allData: this.allEnumerate
      // });
      // this.showUnitOptionsMoney = utils.getAllEnumerateAttr({
      //   isShowList: true,
      //   typeKey: "AmountUnitEnum",
      //   allData: this.allEnumerate
      // });
    })
    this.$http.get('${risk}/rule/business_reminder/getAllDimension').then((res) => {
      if (res.data) {
        res.data.forEach((item) => {
          this.dimensionOptions.push({
            value: item.dimension_key,
            label: item.dimension
          })
        })
      }
    })

    let params = { pageBean: { page: 1, pageSize: 9999, total: 0 } }
    this.$http.post('${portal}/flow/MsgTemplate/v1/listJson', params).then((res) => {
      let response = res.data
      if (response.rows && response.rows.length > 0) {
        response.rows.forEach((item) => {
          this.remindWordOptions.push({
            value: item.key,
            label: item.name
          })
        })
      }
    })
  },
  methods: {
    //input框记录光标位置
    blurEvent(e) {
      this.blurIndex = e.srcElement.selectionStart
    },
    //设置提醒时间
    showNoticeTime() {
      this.noticeTimeShow = true
    },
    closeNoticeTime(val) {
      if (val) {
        this.form.remind_time = val
      }
      this.noticeTimeShow = false
    },
    //变量选择
    setField(val, name) {
      let str = '{' + val.variable_name + ':' + val.variable_key + '}'
      this.form[name] = this.form[name].slice(0, this.blurIndex) + str + this.form[name].slice(this.blurIndex)
    },
    //重置必填项
    resetFields() {
      this.$refs.form && this.$refs.form.resetFields()
    },
    //提醒方式多选
    remindWayChange(val) {
      let str = ''
      if (val) {
        val.forEach((item) => {
          str += item + ','
        })
        str = str.substring(0, str.length - 1)
      }
      this.form.remind_way = str
    },
    //提醒方式多选
    portalTypeChange(val) {
      let str = ''
      if (val) {
        val.forEach((item) => {
          str += item + ','
        })
        str = str.substring(0, str.length - 1)
      }
      this.form.portal_type = str
    },
    //维度选中后联动模板
    dimensionChange(val) {
      this.form.bo_def_key = ''
      this.form.target_key = ''
      this.bodefOptions = []
      this.targetNameOptions = []
      this.dimensionOptions.forEach((item) => {
        if (item.value == val) {
          this.form.dimension = item.label
        }
      })
      this.$http.get('${risk}/rule/business_reminder/getModuleByDimensionKey?key=' + val).then((res) => {
        if (res.data) {
          res.data.forEach((item) => {
            this.bodefOptions.push({
              value: item.bo_def_key,
              label: item.bo_def
            })
          })
        }
      })
    },
    //模板选中后联动指标
    boDefChange(val) {
      this.form.target_key = ''
      this.targetNameOptions = []
      this.bodefOptions.forEach((item) => {
        if (item.value == val) {
          this.form.bo_def = item.label
        }
      })
      this.$http.get('${risk}/rule/business_reminder/getTargetByModuleKey?key=' + val).then((res) => {
        if (res.data) {
          res.data.forEach((item) => {
            this.targetNameOptions.push({
              value: item.target_key,
              label: item.target_name
            })
          })
        }
      })
    },
    //指标选中
    targetChange(val) {
      this.targetNameOptions.forEach((item) => {
        if (item.value == val) {
          this.form.target_name = item.label
        }
      })
    },
    //统计数据
    statisticsDataChange() {},
    //关闭表单
    handleClose() {
      this.$emit('close')
    },
    //提交表单
    handleSave() {
      this.loading = true
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.isEdit) {
            this.$http.put('${risk}/rule/business_reminder/message/', this.form).then((res) => {
              if (res.data.state) {
                this.loading = false
                this.$message.info('保存成功！')
              } else {
                this.loading = false
                this.$message.error('保存失败！')
              }
              this.handleClose()
            })
          }
          if (!this.isEdit) {
            this.$http.post('${risk}/rule/business_reminder/message/', this.form).then((res) => {
              if (res.data.state) {
                this.loading = false
                this.$message.info('保存成功！')
              } else {
                this.loading = false
                this.$message.error('保存失败！')
              }
              this.handleClose()
            })
          }
          setTimeout(() => {
            this.loading = false
          }, 2000)
        } else {
          this.loading = false
          return false
        }
      })
    },
    //设置提醒人
    setPerson() {
      this.showPerson = true
      this.$refs.noticePersonSelectorRef.bindShowValue(this.form.sub_business_reminder_member)
    },
    //设置提醒人关闭
    close() {
      this.showPerson = false
    },
    onConfirm(val, sonTable, str) {
      this.form.reminder_members = str
      this.form.sub_business_reminder_member = sonTable
      this.showPerson = false
    },
    isCanEdit(type) {
      // 距离员工生日天数 本月员工生日  条件控制值不能修改
      if (this.tenantId == '-1') {
        return false
      } else {
        return type === 'birthday_remain_days_month' || type === 'birthday_remain_days'
      }
    }
  }
}
</script>

<style scoped></style>
